import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { ComponentPropsWithoutRef, ElementType } from 'react';
type PageBreadcrumbContainerProps<E extends ElementType = 'div'> = {
  as?: E;
  children?: React.ReactNode;
} & Omit<ComponentPropsWithoutRef<E>, 'as' | 'children'>;
function PageBreadcrumbContainer(t0) {
  const $ = _c(15);
  let as;
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      as,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = children;
    $[3] = className;
    $[4] = props;
  } else {
    as = $[1];
    children = $[2];
    className = $[3];
    props = $[4];
  }
  const Component = as ?? "div";
  let t1;
  if ($[5] !== className) {
    t1 = cn("bg-background fixed top-18 z-50 w-full px-4 pt-4 pb-2 sm:top-27.5 sm:px-0 sm:py-0", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("bg-secondary rounded-xl p-2", "sm:bg-background border-accent sm:h-12 sm:rounded-none sm:border-b sm:px-0 sm:py-3");
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children) {
    t3 = <div data-slot="page-breadcrumb-container-wrapper" className={t2}><div data-slot="page-breadcrumb-container-content" className="sm:container">{children}</div></div>;
    $[8] = children;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== Component || $[11] !== props || $[12] !== t1 || $[13] !== t3) {
    t4 = <Component data-slot="page-breadcrumb-container" className={t1} {...props}>{t3}</Component>;
    $[10] = Component;
    $[11] = props;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
export { PageBreadcrumbContainer };
export type { PageBreadcrumbContainerProps };